import { get } from "./api-service";

export default {
  get: () => get("categories")
};
